import { orgMediaUrl } from '@/core/api';

export function isDirectHttpMediaUrl(url: string | null | undefined): boolean {
  if (!url) return false;
  return /^https?:\/\//i.test(url);
}

interface AssetBinaryImageProps {
  assetId: number;
  endpoint: 'thumbnail' | 'content';
  remoteUrlHint: string | null | undefined;
  alt: string;
  className?: string;
  loadingClassName?: string;
}

export function AssetBinaryImage({
  assetId,
  endpoint,
  remoteUrlHint,
  alt,
  className,
  loadingClassName,
}: AssetBinaryImageProps) {
  const direct = isDirectHttpMediaUrl(remoteUrlHint) ? remoteUrlHint! : null;
  const apiSrc = orgMediaUrl(`/assets/${assetId}/${endpoint}`);

  if (direct) {
    return <img src={direct} alt={alt} className={className} />;
  }

  if (endpoint === 'thumbnail' && !remoteUrlHint) {
    const fallbackCls =
      loadingClassName ??
      'aspectly:w-full aspectly:h-full aspectly:flex aspectly:items-center aspectly:justify-center aspectly:bg-surface-container-high';
    return (
      <div className={fallbackCls}>
        <span className="material-symbols-outlined aspectly:text-on-surface-variant/40 aspectly:text-2xl">image</span>
      </div>
    );
  }

  return <img src={apiSrc} alt={alt} className={className} />;
}

interface AssetBinaryVideoProps {
  assetId: number;
  uriHint: string | null | undefined;
  thumbnailUrlHint: string | null | undefined;
  className?: string;
}

export function AssetBinaryVideo({
  assetId,
  uriHint,
  thumbnailUrlHint,
  className,
}: AssetBinaryVideoProps) {
  const direct = isDirectHttpMediaUrl(uriHint) ? uriHint! : null;
  const videoSrc = direct ?? orgMediaUrl(`/assets/${assetId}/content`);
  const posterDirect = isDirectHttpMediaUrl(thumbnailUrlHint) ? thumbnailUrlHint! : null;
  const posterSrc =
    posterDirect ?? (thumbnailUrlHint ? orgMediaUrl(`/assets/${assetId}/thumbnail`) : undefined);

  return (
    <video src={videoSrc} controls poster={posterSrc} className={className} />
  );
}
